import { Alert, Text } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'

/**
 * As keys desta página são do WhatsApi antigo (EC2), cujo envio não sai pelos gateways
 * do ECS. Chave nova se cria nesta mesma tela, na visão da organização (desde a 1.230.0,
 * spec 2026-11-02 §5.2). Sai junto com a página, na virada da Fase 6.
 */
export function AvisoLegadoEc2() {
  return (
    <Alert icon={<IconInfoCircle size={16} />} color="yellow" variant="light" title="WhatsApi antigo (legado)">
      <Text size="sm">
        As chaves desta página são do WhatsApi antigo e não enviam pelos gateways da organização. Chave nova para
        envio se cria em WhatsApi › API Keys, na visão da organização.
      </Text>
    </Alert>
  )
}
